import React, { useEffect, useState, useRef } from 'react'
import Icon from 'components/Icon'
import EmbeddedPdf from 'components/EmbeddedPdf'

const EmbeddedNda = ({ match: { params: { supplierId } } }) => {
  const [pdfUrl, setPdfUrl] = useState(null)
  const interval = useRef(null)

  useEffect(() => {
    interval.current = setInterval(() => {
        fetch(`/supplierNda/show?supplierId=${supplierId}`, { credentials: 'same-origin' })
          .then((response) => response.json())
          .then(({ success, data }) => {
            if (success) {
              setPdfUrl(data.cdn_url)
              clearInterval(interval.current)
            }
          })
          .catch((error) => {
            window.alert(error)
            clearInterval(interval.current)
          })
    }, 2000)

    return () => {
      if (interval.current) {
        clearInterval(interval.current)
      }
    }
  }, [])

  return (
    <EmbeddedPdf pdfUrl={pdfUrl} />
  )
}

export default EmbeddedNda
